import type Swiper from 'swiper';
import { ref, Ref } from 'vue';

const swiper: Ref<Swiper | null> = ref(null);
export const activeIndex = ref(0);

export default swiper;
